import PropTypes from 'prop-types';
import React from 'react';
import { Box, Flex, Text } from 'rebass/styled-components';
import { ProfilePicture } from '@getro/rombo';
import Experience from './components/experience';
import TruncatedText from './components/truncatedText';
import CompanyDataTable from './components/companyDataTable';
import FundingTable from './components/fundingTable';
import CompanySizeGraph from './components/companySizeGraph';
import FinancialGraph from './components/financialGraph';

const Company = ({ company, contact }) => {
  const workExpereinceInCompany = contact.contactWorkExperiences
    .filter((experience) => experience?.organization?.id === company.id)
    .sort((a, b) => {
      const dateA = a.dateFrom ? new Date(a.dateFrom) : new Date(0);
      const dateB = b.dateFrom ? new Date(b.dateFrom) : new Date(0);
      return dateB - dateA; // Sort descending (most recent first)
    });

  return (
    <Box mb="40px">
      <Flex alignItems="center" sx={{ gap: '8px', marginBottom: '8px' }}>
        <ProfilePicture name={company?.name} imageUrl={company?.logoUrl} width="32px" height="32px" variant="square" />
        <Text fontSize="16px" fontWeight="medium" color="text.dark">
          {company?.name}
        </Text>
      </Flex>
      <Flex flexDirection="column" sx={{ gap: '4px', marginBottom: '24px' }}>
        {workExpereinceInCompany?.map((experience) => (
          <Experience experience={experience} />
        ))}
      </Flex>
      <div style={{ marginBottom: '16px' }}>
        <Text
          fontSize="12px"
          fontWeight="medium"
          marginBottom="8px"
          sx={{ color: 'text.subtle', letterSpacing: '1px', textTransform: 'uppercase' }}
        >
          Summary
        </Text>
        <TruncatedText text={company?.description} maxLength={250} />
      </div>
      <div style={{ marginBottom: '16px' }}>
        <CompanyDataTable company={company} />
      </div>

      {company.organizationSizes && company.organizationSizes.length > 0 && (
        <CompanySizeGraph
          profileName={contact.fullName}
          organizationSizes={company.organizationSizes}
          workExpereinceInCompany={workExpereinceInCompany}
        />
      )}

      {company.organizationFinancialInfos && company.organizationFinancialInfos.length > 0 && (
        <FinancialGraph
          profileName={contact.fullName}
          organizationFinancialInfos={company.organizationFinancialInfos}
          workExpereinceInCompany={workExpereinceInCompany}
        />
      )}

      {company.organizationStages && company.organizationStages.length > 0 && (
        <FundingTable organizationStages={company.organizationStages} />
      )}
    </Box>
  );
};

Company.propTypes = {
  company: PropTypes.object.isRequired,
  contact: PropTypes.object.isRequired,
};

export default Company;
